var _mask, _path, _path2, _path3, _mask2, _path4, _path5, _path6, _mask3, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgListIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 16,
  fill: "none",
  viewBox: "0 0 18 16"
}, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
  id: "list-icon_svg__a",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M2 2.9a.9.9 0 1 0 0-1.8.9.9 0 0 0 0 1.8M2 4a2 2 0 1 0 0-4 2 2 0 0 0 0 4",
  clipRule: "evenodd"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M2 2.9a.9.9 0 1 0 0-1.8.9.9 0 0 0 0 1.8M2 4a2 2 0 1 0 0-4 2 2 0 0 0 0 4",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M2.9 2H1.8c0-.11.09-.2.2-.2V4a2 2 0 0 0 2-2zM2 1.1v1.1a.2.2 0 0 1-.2-.2H4a2 2 0 0 0-2-2zm-.9.9h1.1a.2.2 0 0 1-.2.2V0a2 2 0 0 0-2 2zm.9.9V1.8c.11 0 .2.09.2.2H0a2 2 0 0 0 2 2zM4 2H2.9a.9.9 0 0 1-.9.9v2.2A3.1 3.1 0 0 0 5.1 2zM2 0v1.1a.9.9 0 0 1 .9.9h2.2A3.1 3.1 0 0 0 2-1.1zM0 2h1.1a.9.9 0 0 1 .9-.9v-2.2A3.1 3.1 0 0 0-1.1 2zm2 2V2.9a.9.9 0 0 1-.9-.9h-2.2A3.1 3.1 0 0 0 2 5.1z",
  mask: "url(#list-icon_svg__a)"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  d: "M6.5 1.5h11"
})), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
  id: "list-icon_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M2 8.9a.9.9 0 1 0 0-1.8.9.9 0 0 0 0 1.8M2 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4",
  clipRule: "evenodd"
}))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M2 8.9a.9.9 0 1 0 0-1.8.9.9 0 0 0 0 1.8M2 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4",
  clipRule: "evenodd"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M2.9 8H1.8c0-.11.09-.2.2-.2V10a2 2 0 0 0 2-2zM2 7.1v1.1a.2.2 0 0 1-.2-.2H4a2 2 0 0 0-2-2zm-.9.9h1.1a.2.2 0 0 1-.2.2V6a2 2 0 0 0-2 2zm.9.9V7.8c.11 0 .2.09.2.2H0a2 2 0 0 0 2 2zM4 8H2.9a.9.9 0 0 1-.9.9v2.2A3.1 3.1 0 0 0 5.1 8zM2 6v1.1a.9.9 0 0 1 .9.9h2.2A3.1 3.1 0 0 0 2 4.9zM0 8h1.1a.9.9 0 0 1 .9-.9V4.9A3.1 3.1 0 0 0-1.1 8zm2 2V8.9a.9.9 0 0 1-.9-.9h-2.2A3.1 3.1 0 0 0 2 11.1z",
  mask: "url(#list-icon_svg__b)"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  d: "M6.5 7.5h11"
})), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
  id: "list-icon_svg__c",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M2 14.9a.9.9 0 1 0 0-1.8.9.9 0 0 0 0 1.8M2 16a2 2 0 1 0 0-4 2 2 0 0 0 0 4",
  clipRule: "evenodd"
}))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M2 14.9a.9.9 0 1 0 0-1.8.9.9 0 0 0 0 1.8M2 16a2 2 0 1 0 0-4 2 2 0 0 0 0 4",
  clipRule: "evenodd"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M2.9 14H1.8c0-.11.09-.2.2-.2V16a2 2 0 0 0 2-2zm-.9-.9v1.1a.2.2 0 0 1-.2-.2H4a2 2 0 0 0-2-2zm-.9.9h1.1a.2.2 0 0 1-.2.2V12a2 2 0 0 0-2 2zm.9.9v-1.1c.11 0 .2.09.2.2H0a2 2 0 0 0 2 2zm2-.9H2.9a.9.9 0 0 1-.9.9v2.2A3.1 3.1 0 0 0 5.1 14zm-2-2v1.1a.9.9 0 0 1 .9.9h2.2A3.1 3.1 0 0 0 2 10.9zm-2 2h1.1a.9.9 0 0 1 .9-.9v-2.2A3.1 3.1 0 0 0-1.1 14zm2 2v-1.1a.9.9 0 0 1-.9-.9h-2.2A3.1 3.1 0 0 0 2 17.1z",
  mask: "url(#list-icon_svg__c)"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  d: "M6.5 13.5h11"
})));
export { SvgListIcon as ReactComponent };